import * as React from "react";
import {
  CellContext,
  ColumnDef,
  createColumnHelper
} from "@tanstack/react-table";

import { customCreateColumnHelper } from "src/core/dashboard/components/widgets/table/customColumnHelper";
import { IPriceList } from "src/core/shared/api/price-change.api";

export interface IPriceListColumns {
  //buttons for each list
  actionButton: (info: CellContext<IPriceList, unknown>) => React.ReactNode,
  //ability to choose columns outside of this file
  columns?: PriceListColumnsPicked[]
}

type PriceListColumnsPicked = keyof AvailablePriceListColumns;

interface AvailablePriceListColumns{
  id: ColumnDef<IPriceList, string | number | boolean | undefined>,
  name: ColumnDef<IPriceList, string | number | boolean | undefined>,
  code: ColumnDef<IPriceList, string | number | boolean | undefined>,
  createdAt: ColumnDef<IPriceList, string | number | boolean | undefined>,
  updatedAt: ColumnDef<IPriceList, string | number | boolean | undefined>,
  action: ColumnDef<IPriceList, string | number | boolean | undefined>,

}

/** columns for Price List Columns*/
export const getPriceListColumns = (params: IPriceListColumns) => {
  const customColumnHelper = customCreateColumnHelper<IPriceList>();
  const ColumnHelper = createColumnHelper<IPriceList>();

  const AllColumns: AvailablePriceListColumns = {
    id: customColumnHelper.numberColumn(ColumnHelper, "id", { header: "ID" }),
    name: customColumnHelper.standardTextColumn(ColumnHelper, "name", { header: "Name" }),
    code: customColumnHelper.standardTextColumn(ColumnHelper, "code", { header: "Code" }),
    createdAt: customColumnHelper.dateColumn(ColumnHelper, "createdAt", { header: "Created" }),
    updatedAt: customColumnHelper.dateColumn(ColumnHelper, "updatedAt", { header: "Updated" }),
    action: customColumnHelper.actionColumn(ColumnHelper, params.actionButton, {})
  };

  if (params.columns) {
    return params.columns.map(column => AllColumns[ column ]);
  } else {
    return Object.values(AllColumns);
  }
};
